import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isAppUserLoading = (state: TRootState): boolean =>
  arrayContains(state.appUser.openRequests, [
    Actions.findAppUserRequest.type,
    Actions.findAppUsersRequest.type,
    Actions.searchAppUsersRequest.type,
    Actions.createAppUserRequest.type,
    Actions.updateAppUserRequest.type,
    Actions.deleteAppUserRequest.type,
  ]);
